/**
 * @func vuex-getters
 */
var getters = {
  currentState: function currentState(state) {
    return state.login.currentState;
  },
  // 当前步骤
  currentLoginType: function currentLoginType(state) {
    return state.login.currentLoginType;
  },
  // 当前登录类型
  isQrLogin: function isQrLogin(state) {
    return state.login.isQrLogin;
  },
  // 是否是二维码扫码登录
  pswData: function pswData(state) {
    return state.login.pswData;
  },
  // 密码验证返回的信息
  userData: function userData(state) {
    return state.login.userData;
  },
  // 帐号验证返回的信息
  userMobile: function userMobile(state) {
    return state.login.userMobile;
  },
  // 找回密码用户手机号信息
  loginInfo: function loginInfo(state) {
    return state.login.loginInfo;
  },
  // 登录的数据
  ruleState: function ruleState(state) {
    return state.login.ruleState;
  },
  // 密码规则
  url: function url(state) {
    return state.login.url;
  },
  domains: function domains(state) {
    return state.login.domains;
  },
  wudomain: function wudomain(state) {
    return state.login.wudomain;
  },
  buttjoint: function buttjoint(state) {
    return state.login.buttjoint;
  },
  // 接入方忘记密码
  protocolVisible: function protocolVisible(state) {
    return state.login.protocolVisible;
  },
  privacyVisible: function privacyVisible(state) {
    return state.login.privacyVisible;
  },
  serviceUrl: function serviceUrl(state) {
    return state.init.serviceUrl;
  },
  appConfig: function appConfig(state) {
    return state.init.appConfig;
  },
  appConfigValid: function appConfigValid(state) {
    return state.init.appConfigValid;
  },
  // 账号探活
  oaProbeInfo: function oaProbeInfo(state) {
    return state.init.oaProbeInfo;
  },
  // 账号探活初始化信息及必要参数
  // maia在线参数
  maiaParams: function maiaParams(state) {
    return state.maia.maiaParams;
  },
  // 网络
  network_online: function network_online(state) {
    return state.network.network_online;
  }
};
export default getters;